import { JSX, Show } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";

/**
 * Title section with brand name and optional discount badge
 * Responsive typography: larger on desktop, smaller on mobile
 */
export function TitleSection(): JSX.Element {
  const { routeData, simulateData } = useBrandl2WebstoreTelescopeContext();

  const brandName = () => routeData().brand.name;
  const brandTitle = () => routeData().brand.voucherProductMetadata.title;

  const discountPercentage = () => {
    return simulateData()?.discountDetails?.hubbleBaseDiscount?.percentage ?? 0;
  };

  return (
    <div class=" flex w-full flex-col gap-0 text-title-2-semi-bold text-text-normal-primary">
      {/* Main Title */}
      <h1 class="  ">{brandTitle() || brandName()} card</h1>

      {/* Subtitle with optional discount badge */}
      <Show when={discountPercentage() > 0}>
        <div class="inline-flex items-center gap-1">
          at
          <span class="text-success-base">{discountPercentage()}% off</span>
        </div>
      </Show>
    </div>
  );
}
